import './App.css';
import Menu from './js/Menu';

function App() {
  return (
    <div className="App">
      <Menu></Menu>
    </div>
  );
}

export default App;
